import React from "react";
import { Link } from "react-router-dom";

import "./DigitalDeclutter.css";

export default function DigitalDeclutter() {
  
  return (
    <div className="declutter-wrapper">
      {/* Hero Section */}
      <section className="declutter-hero">
        <div className="hero-content">
          <h1>Digital Declutter</h1>
          <p>Reduce notifications without losing focus.</p>
        </div>
      </section>

      {/* Main Content */}
      <main className="declutter-container">
        <h2>Make Your Devices Feel Calmer & More Intentional</h2>
        <p className="intro-text">
          Find out how a few simple steps can make your digital space more peaceful. 
          A cluttered device leads to a cluttered mind — but you don’t need a full 
          detox. Just small, intentional changes create real calm.
        </p>

        {/* Sections */}
        <section className="declutter-section">
          <h3>🔕 Disable Non-Essential Notifications</h3>
          <p>
            Turn off notifications for apps that don’t require real-time attention.  
            Your focus is your most valuable asset — protect it.
          </p>
        </section>

        <section className="declutter-section">
          <h3>📂 Clean Up Your Home Screen</h3>
          <p>
            Keep only the essential apps visible. Move the rest into folders or secondary screens.  
            Make your device feel like a *tool*, not a distraction.
          </p>
        </section>

        <section className="declutter-section">
          <h3>⏳ Set “Check-in Times”</h3>
          <p>
            Instead of checking messages constantly, schedule short windows during the day  
            to review updates. This resets your relationship with technology.
          </p>
        </section>

        <section className="declutter-section">
          <h3>🌓 Evening Digital Boundary</h3>
          <p>
            One hour before bed, switch to **Do Not Disturb** mode.  
            Your brain needs space to unwind — let it.
          </p>
        </section>

        <section className="declutter-section">
          <h3>📱 One-Minute Lock Screen Audit</h3>
          <p>
            Ask yourself: *Do I really need this app to be this accessible?*  
            If not — move it away. Your lock screen should represent clarity.
          </p>
        </section>
      </main>

      {/* Footer */}
      <footer className="declutter-footer">
        <p>© 2025 CalmNote Wellness • Clearing Digital Noise, One Step at a Time</p>
      </footer>
    </div>
  );
}

